import { mapKeys, mapValues, isPlainObject, snakeCase } from 'lodash'

function deepSnakeCaseKeys(obj) {
  if (obj == null) return obj
  if (Array.isArray(obj)) return obj.map(deepSnakeCaseKeys)
  if (!isPlainObject(obj)) return obj
  return mapValues(
    mapKeys(obj, (_, k) => snakeCase(k)),
    (v) => deepSnakeCaseKeys(v)
  )
}

function getItemId(item) {
  if (item == null) return null
  if (typeof item === 'object') {
    if (item.id != null) return item.id
    return null
  }
  return item
}

function stringifyAnswerableValue(rawValue, idToLabelMap) {
  if (rawValue == null) return rawValue

  const rawItems = Array.isArray(rawValue) ? rawValue : [rawValue]
  const labels = rawItems
    .map((item) => {
      if (typeof item === 'string' && item.trim() !== '' && isNaN(Number(item)))
        return item.trim()

      const id = getItemId(item)
      if (id == null || String(id).trim() === '') return null
      return idToLabelMap[String(id)] || String(id)
    })
    .filter(Boolean)

  if (!labels.length) return Array.isArray(rawValue) ? '' : rawValue
  return labels.join(', ')
}

function serializeStep2Values(step2, serializationConfig = {}) {
  const answerableTypeByVariable =
    serializationConfig.answerableTypeByVariable || {}
  const idToLabelByAnswerableType =
    serializationConfig.idToLabelByAnswerableType || {}

  return Object.keys(step2 || {}).reduce((acc, variable) => {
    const answerableType = answerableTypeByVariable[variable]
    const idToLabelMap = answerableType
      ? idToLabelByAnswerableType[answerableType]
      : null

    if (!idToLabelMap) {
      acc[variable] = step2[variable]
      return acc
    }

    acc[variable] = stringifyAnswerableValue(step2[variable], idToLabelMap)
    return acc
  }, {})
}

function normalizeStep1ProfilePic(step1) {
  const normalizedStep1 = deepSnakeCaseKeys(step1 || {})

  if (
    normalizedStep1.profile_pic == null &&
    normalizedStep1.profile_picture != null
  ) {
    normalizedStep1.profile_pic = normalizedStep1.profile_picture
  }

  delete normalizedStep1.profile_picture
  return normalizedStep1
}

/**
 * Body for POST /authentication/teaching_artist_applications
 * (wrapped in teaching_artist_application by api-actions).
 */
export default function buildTeachingArtistApplicationPayload(
  step1,
  step2,
  programs,
  step2SerializationConfig
) {
  const programsClean = (programs || []).map((p) => {
    if (!p || typeof p !== 'object') return p
    const { clientId, ...rest } = p
    void clientId
    return deepSnakeCaseKeys(rest)
  })
  const step2Serialized = serializeStep2Values(
    deepSnakeCaseKeys(step2 || {}),
    step2SerializationConfig
  )

  return {
    step1: normalizeStep1ProfilePic(step1),
    step2: step2Serialized,
    programs: programsClean,
  }
}
